module.exports = __webpack_public_path__ + "img/robbie-williams.363c77b3.jpg";